<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <el-input
          v-model="value"
          :min="min"
          :max="max"
          type="number"
          :placeholder="placeholder"
          :step="step"
          :disabled="!selectStatus"
          @change="changeOptionCSS"
        />
      </div>
      <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOptionCSS" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "NumberCSS",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Number, String],
      default: 0,
    },
    hint: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 0,
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
    },
  },
  data() {
    return {
      value: this.default,
      selectStatus: this.status,
      showHint: false,
    };
  },
  computed: {
    ...mapState(["clearOptionsCSS"]),
  },
  watch: {
    clearOptionsCSS(val) {
      if (val) {
        this.selectStatus = false;
      }
    },
    eventClick(val) {
      this.selectStatus = val;
      this.value = this.default;
    },
    selectStatus(val) {
      if (val === true) {
        this.changeOptionCSS();
      }
    },
  },
  methods: {
    changeOptionCSS() {
      const value =
        this.selectStatus === true && this.value !== ""
          ? `${this.value}` + (this.value.includes("px") ? "" : "px")
          : "";
      this.$emit("changeOptionCSS", {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ":",
        value: `${value}`,
      });
    },
  },
};
</script>
